import { render, staticRenderFns } from "./manager-list.vue?vue&type=template&id=5adf2c52&scoped=true&lang=pug"
import script from "./manager-list.vue?vue&type=script&lang=js"
export * from "./manager-list.vue?vue&type=script&lang=js"
import style0 from "./manager-list.vue?vue&type=style&index=0&id=5adf2c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf2c52",
  null
  
)

export default component.exports